// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-form-item__content[data-v-5642de0d] {\n  margin-left: 0px !important;\n  margin-bottom: 0 !important;\n}\n.el-form-item[data-v-5642de0d] {\n  margin-bottom: 0;\n}\n.el-row--flex.is-justify-end[data-v-5642de0d] {\n  margin-top: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
